import { render, staticRenderFns } from "./releaseFail.vue?vue&type=template&id=df2d7bc8&scoped=true"
import script from "./releaseFail.vue?vue&type=script&lang=js"
export * from "./releaseFail.vue?vue&type=script&lang=js"
import style0 from "./releaseFail.vue?vue&type=style&index=0&id=df2d7bc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2d7bc8",
  null
  
)

export default component.exports